import { createLoaderRuntime } from './loaderRuntime.mjs'

export default createLoaderRuntime()
